<template>
  <div id="notes">
    <div class="row">
      <div class="reportSection">
        <section-heading>
          <div slot="title">Notes</div>
        </section-heading>
      </div>
    </div>
    <div v-if="notes.length > 0" class="panel panel-default">
      <div class="panel-body">
        <note v-for="note in notes" :key="note.id" :note="note" />
      </div>
    </div>
    <div class="sectionBreak row" />
    <div class="panel panel-default summaryPanel">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12">
            <h5 v-if="notes.length > 0">Add another note</h5>
            <h5 v-else>Add a note</h5>
            <p>
              You can record notes against this company. Notes will be visible to you and your
              colleagues when they run or review reports against this company. Notes are
              <strong>not</strong> included in PDF reports.
            </p>
            <p>
              You can delete your notes but you can't delete the notes written by your colleagues.
            </p>
          </div>
        </div>
        <validation-observer class="row" ref="observer" tag="div" v-slot="{ invalid }">
          <div class="form-group col-xs-10">
            <label for="noteLabel" class="control-label">Note</label>
            <validation-provider
              name="note"
              mode="eager"
              rules="required|min:5"
              v-slot="{ errors }"
            >
              <textarea
                type="text"
                class="form-control"
                id="noteLabel"
                v-model="newNote"
                placeholder="A note"
                name="noteLabel"
                @keyup="$refs.observer.validate()"
                required
              ></textarea>
              <span class="text-danger field-validation-error">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="form-group col-xs-2 text-center" style="margin-top: 20px">
            <button
              type="button"
              id="addNote"
              class="btn btn-success"
              v-on:click="addNote"
              :disabled="invalid || working"
              style="width: 86px"
            >
              <template v-if="working"> Saving </template>
              <template v-else> Add note </template>
            </button>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeading from '@/components/reports/components/SectionHeading';
import Axios from '@/packages/axios/Axios';
import Note from '../../panels/Note';

export default {
  components: {
    Note,
    SectionHeading,
  },
  data() {
    return {
      newNote: '',
      working: false,
    };
  },
  methods: {
    addNote() {
      this.working = true;
      Axios.post('/v1/reports/' + this.$route.params.reportId + '/notes', {
        note: this.newNote,
      })
        .then(() => {
          this.newNote = '';
          this.$refs.observer.reset();
        })
        .catch((e) => {
          if (e.response) {
            this.errors.push(e);
            switch (e.response.status) {
              case 401:
                this.$router.push('/error/401');
                break;
              case 403:
                this.$router.push('/error/403');
                break;
              case 404:
                this.$router.push('/error/404');
                break;
              default:
                this.$router.push('/error/unknown');
            }
          }
        });
    },
  },
  name: 'Notes',
  props: {
    notes: {
      required: true,
      type: Array,
    },
  },
  watch: {
    notes: {
      deep: true,
      handler(newNotes) {
        this.working = false;
      },
    },
  },
};
</script>

<style scoped></style>
